import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Directive({
  selector: '[appSmallTableRowModify]',
})
/**
 * 在第一個元素中加入 title，模擬小版面的 th 顯示
 */
export class SmallTableRowModifyDirective implements AfterViewInit {
  tr!: Element;
  @Input() headerList: string[] = [];

  constructor(e: ElementRef, private translateService: TranslateService) {
    this.tr = e.nativeElement;
  }
  ngAfterViewInit(): void {
    const tr: Element = this.tr;
    const headerList: string[] = this.updateHeaderListWithTranslate();
    const childNodes: NodeListOf<ChildNode> = tr.childNodes;

    if (tr && tr.parentElement instanceof Element) {
      tr.parentElement.classList.add('small-table-body');
      if (tr.parentElement.previousSibling instanceof Element) {
        tr.parentElement.previousSibling.classList.add('small-table-thead');
      }
    }
    tr.classList.add('small-table-row');
    Array.from(childNodes).forEach((td, index) => {
      if (headerList[index]) {
        const titleElement = this.createTitleElement(headerList[index]);
        td.insertBefore(titleElement, td.firstChild);
      }
    });
  }
  /**
   * tranlate
   */
  updateHeaderListWithTranslate(): string[] {
    let result: string[] = [];
    const headerList = this.headerList;
    const translateService = this.translateService;
    if (Array.isArray(headerList) && headerList.length > 0) {
      result = headerList.map((word) => {
        const nw = word ? translateService.instant(word) : '';
        return nw;
      });
    }
    return result;
  }
  /**
   * create HTML element
   */
  createTitleElement(text: string): Element {
    const element = document.createElement('div');
    element.innerHTML = text;
    element.classList.add('small-table-row-title');
    return element;
  }
}
